import { useState } from 'react';

export default function VideoInstitucional() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section id="video" className="py-20 relative overflow-hidden" style={{ backgroundColor: '#2d7aa6' }}>
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-15">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 bg-teal-500/20 text-teal-400 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-play-circle-line text-lg"></i>
            Conócenos mejor
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Video Institucional
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Descubre cómo el CDE MIPYME Región Valle de Sula impulsa el crecimiento 
            y la competitividad de las micro, pequeñas y medianas empresas de Honduras.
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 group">
            {/* Video Thumbnail / Player */}
            {!isPlaying ? (
              <div className="relative aspect-video">
                <img
                  src="https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/7a4daf9b36e21fceefc938828b031eb2.png"
                  alt="Video institucional CDE MIPYME"
                  className="w-full h-full object-cover object-top"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/40 to-transparent"></div>
                
                {/* Play Button */}
                <button
                  onClick={() => setIsPlaying(true)}
                  className="absolute inset-0 flex items-center justify-center cursor-pointer group/btn"
                >
                  <div className="relative">
                    {/* Pulse animation */}
                    <div className="absolute inset-0 bg-teal-500 rounded-full animate-ping opacity-30"></div>
                    <div className="relative w-20 h-20 md:w-24 md:h-24 bg-teal-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover/btn:scale-110 shadow-lg shadow-teal-500/50">
                      <i className="ri-play-fill text-4xl md:text-5xl text-white ml-1"></i>
                    </div>
                  </div>
                </button>

                {/* Video Info Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <div className="flex items-center gap-4 text-white/80 text-sm">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      3:45 min
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      2,500+ vistas
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="aspect-video bg-black">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/WwWmcQcrjGw?autoplay=1&rel=0"
                  title="Video Institucional CDE MIPYME"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}

            {/* Border glow effect */}
            <div className="absolute inset-0 rounded-2xl border border-teal-500/20 pointer-events-none"></div>
          </div>

          {/* Close button when playing */}
          {isPlaying && (
            <button
              onClick={() => setIsPlaying(false)}
              className="mt-4 mx-auto flex items-center gap-2 text-slate-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-circle-line"></i>
              Cerrar video
            </button>
          )}
        </div>

        {/* Video Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 max-w-4xl mx-auto">
          <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-teal-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-2xl text-teal-400"></i>
            </div>
            <h3 className="text-white font-semibold mb-2">Nuestro Equipo</h3>
            <p className="text-slate-300 text-sm">
              Profesionales comprometidos con el desarrollo empresarial regional
            </p>
          </div>

          <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-2-line text-2xl text-emerald-400"></i>
            </div>
            <h3 className="text-white font-semibold mb-2">Instalaciones</h3>
            <p className="text-slate-300 text-sm">
              Espacios modernos para capacitación y asesoría empresarial
            </p>
          </div>

          <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-line-chart-line text-2xl text-cyan-400"></i>
            </div>
            <h3 className="text-white font-semibold mb-2">Impacto</h3>
            <p className="text-slate-300 text-sm">
              Resultados tangibles en el crecimiento de las MIPYMES
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#contacto"
            className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/30 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            Agenda una cita con nosotros
          </a>
        </div>
      </div>
    </section>
  );
}
